export class CookieManager {
    public get(name) {
        const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return match ? decodeURIComponent(match[2]) : null;
    }

    public exists(name) {
        return document.cookie.split('; ').some(row => row.startsWith(name + '='));
    }

    public set(name, value, days = 7, options = {}) {
        let expires = '';
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = `; expires=${date.toUTCString()}`;
        }
        let cookieStr = `${name}=${encodeURIComponent(value || '')}${expires}; path=${options.path || '/'}`;
        if (options.domain) cookieStr += `; domain=${options.domain}`;
        if (options.secure) cookieStr += `; Secure`;
        if (options.sameSite) cookieStr += `; SameSite=${options.sameSite}`;
        document.cookie = cookieStr;
    }

    public delete(name, options = {}) {
        if (!this.exists(name)) return false;
        let cookieStr = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${options.path || '/'}`;
        if (options.domain) cookieStr += `; domain=${options.domain}`;
        document.cookie = cookieStr;
        return true;
    }
}